import { generateRequestId } from "../AjaxRequestBroker";

/*
// list of fonts from annotations.js (i.e. original/prod list)
this.fonts = [
    {"Architects Daughter" : "'Architects Daughter', cursive"},
    {"Arimo":"'Arimo', sans-serif"},
    {"Chewy":"'Chewy', cursive"},
    {"Changa One":"'Changa One', cursive"},
    {"Droid Serif":"'Droid Serif', serif"},
    {"Indie Flower":"'Indie Flower', cursive"},
    {"Josefin-Slab":"'Josefin Slab', sans-serif"},
    {"Lato":"'Lato', sans-serif"},
    {"Lora":"'Lora', sans-serif"},
    {"Open-Sans":"'Open Sans', sans-serif"},
    {"Oswald":"'Oswald', serif"},
    {"Patrick Hand":"'Patrick Hand', cursive"},
    {"Playfair Display":"'Playfair Display', serif"},
    {"PT Serif":"'PT Serif', serif"},
    {"Roboto-Condensed":"'Roboto Condensed', sans-serif"},
    {"Roboto-Mono":"'Roboto Mono', mono"}
]
*/

const es = global.es;

export const ATLAS_SUPPORTED_FONTS = [
    "SegoeFrutigerHelveticaMYingHei-Bold",
    "SegoeFrutigerHelveticaMYingHei-Medium",
    "SegoeFrutigerHelveticaMYingHei-Regular",
    /*
    although these are supported by atlas, the bolditalic variant is not, so for consistency, we host it ourselves in the "glyphes" dir
    "SegoeUi-Bold",
    "SegoeUi-Light",
    "SegoeUi-Regular",
    "SegoeUi-SemiBold",
    "SegoeUi-SemiLight",
    "SegoeUi-SymbolRegular",
    "StandardCondensedSegoeUi-Black",
    "StandardCondensedSegoeUi-Bold",
    "StandardCondensedSegoeUi-Light",
    "StandardCondensedSegoeUi-Regular",
    "StandardFont-Black",
    "StandardFont-Bold",
    "StandardFont-Light",
    "StandardFont-Regular",
    "StandardFontCondensed-Black",
    "StandardFontCondensed-Bold",
    "StandardFontCondensed-Light",
    "StandardFontCondensed-Regular"
     */
];

export type FontVariant = {
    name: string;
    title: string;
    family: string;
    isItalic: boolean;
    isBold: boolean;
    isSupported: boolean;
    alt: string;
};

export const ES_SYSTEM_FONTS : FontVariant[] = [

    // total number of layerviews in prod at time of writing: 935k, 230k have labels
    { name: 'StandardFont',       title: 'Standard Font',         family: "'Standard Font', sans-serif",      isSupported: true, isItalic: false, isBold: true, alt: "" }, // new
    { name: 'SegoeUi',            title: 'Segoe Ui',              family: "'Segoe Ui', sans-serif",           isSupported: true, isItalic: true,  isBold: true,  alt: "" }, // new

    // existing and supported or partially supported
    { name: 'Roboto',             title: 'Roboto',                family: "'Roboto', sans-serif",             isSupported: true, isItalic: true,  isBold: true,  alt: "" }, // 757
    { name: 'Arimo',              title: 'Arimo',                 family: "'Arimo', sans-serif",              isSupported: true, isItalic: true,  isBold: true,  alt: "" }, // 227,611
    { name: 'ChangaOne',          title: 'Changa One',            family: "'Changa One', cursive",            isSupported: true, isItalic: true,  isBold: false, alt: "" }, // 134
    { name: 'PatrickHand',        title: 'Patrick Hand',          family: "'Patrick Hand', cursive",          isSupported: true, isItalic: false, isBold: false, alt: "" }, // 58
    { name: 'ArchitectsDaughter', title: 'Architects Daughter',   family: "'Architects Daughter', cursive",   isSupported: true, isItalic: false, isBold: false, alt: "" }, // 22
    { name: 'Chewy',              title: 'Chewy',                 family: "'Chewy', cursive",                 isSupported: true, isItalic: false, isBold: false, alt: "" }, // 21
    { name: 'IndieFlower',        title: 'Indie Flower',          family: "'Indie Flower', cursive",          isSupported: true, isItalic: false, isBold: false, alt: "" }, // 4

    // existing and not supported
    // TODO: we could do with support at least one of each of these types: mono, condensed, serif
    { name: 'Open-Sans',          title: 'Open Sans',             family: "'Open Sans', sans-serif",          isSupported: false, isItalic: false, isBold: false, alt: "Arimo" }, // 2,208
    { name: 'Lato',               title: 'Lato',                  family: "'Lato', sans-serif",               isSupported: false, isItalic: false, isBold: false, alt: "Arimo" }, // 818
    { name: 'Oswald',             title: 'Oswald',                family: "'Oswald', serif",                  isSupported: false, isItalic: false, isBold: false, alt: "Arimo" }, // 749
    { name: 'Roboto-Condensed',   title: 'Roboto Condensed',      family: "'Roboto Condensed', sans-serif",   isSupported: false, isItalic: false, isBold: false, alt: "Arimo" }, // 596
    { name: 'Lora',               title: 'Lora',                  family: "'Lora', sans-serif",               isSupported: false, isItalic: false, isBold: false, alt: "Arimo" }, // 226
    { name: 'DroidSerif',         title: 'Droid Serif',           family: "'Droid Serif', serif",             isSupported: false, isItalic: false, isBold: false, alt: "Arimo" }, // 209
    { name: 'PTSerif',            title: 'PT Serif',              family: "'PT Serif', serif",                isSupported: false, isItalic: false, isBold: false, alt: "Arimo" }, // 226
    { name: 'Roboto-Mono',        title: 'Roboto Mono',           family: "'Roboto Mono', mono",              isSupported: false, isItalic: false, isBold: false, alt: "Arimo" }, // 161
    { name: 'PlayfairDisplay',    title: 'Playfair Display',      family: "'Playfair Display', serif",        isSupported: false, isItalic: false, isBold: false, alt: "Arimo" }, // 126
    { name: 'Josefin-Slab',       title: 'Josefin Slab',          family: "'Josefin Slab', sans-serif",       isSupported: false, isItalic: false, isBold: false, alt: "Arimo" }, // 15
];

/**
 * Get a font value compatible with Azure with a font-family value compatible with from Google.
 * @param fontFamily e.g. "'Josefin Slab', sans-serif"
 * @param isBold if font is requested to be bold (may not be supported)
 * @param isItalic if font is requested to be italic (may not be supported)
 */
export function getAzureFontFromGoogleFont(fontFamily: string, isBold: boolean, isItalic: boolean): string {

    function getPostFix(f: FontVariant) {
        let postfix;
        if (isBold && isItalic && f.isBold && f.isItalic) {
            postfix = "-BoldItalic";
        } else if (isBold && f.isBold) {
            postfix = "-Bold";
        } else if(isItalic && f.isItalic){
            postfix = "-Italic";
        } else {
            postfix = "-Regular";
            //postfix = "";
        }
        //console.log("getPostFix", fontFamily, isBold, isItalic, f, postfix);
        return postfix;
    }

    const f = ES_SYSTEM_FONTS.find(f => f.family === fontFamily || f.name === fontFamily) as FontVariant;
    if(f){
        let rsFont;
        if(!f.isSupported){
            if(f.alt.length > 0) {
                rsFont = f.alt + getPostFix(f);
                console.log("Unsupported font with fallback", fontFamily, f, "returning", rsFont);
                return rsFont;
            } else {
                console.warn("Unsupported font with no fallback", fontFamily, f);
            }
        } else {
            rsFont = f.name + getPostFix(f);
            //console.log("Supported font", fontFamily, f);
            return rsFont;
        }
    } else {
        console.error("Unsupported font with unhandled fontFamily", fontFamily);
    }

    const defaultFont = ES_SYSTEM_FONTS[0].name + getPostFix(f);
    console.log("Setting font to default", defaultFont);
    return defaultFont;
}

/**
 * transformRequest is a pre-flight request processor that allows us alter requests just before they're sent.
 * Since azure only supports a very limited set of fonts, we can add support for more here by hosting our own
 * and rewriting the request before it's sent.
 * Also adds X-Request-Id header for requests to eSpatial server for log correlation.
 * See: https://learn.microsoft.com/en-us/azure/azure-maps/map-create#request-transforms *
 * See: AzureBaseMap.ts transformRequest
 */
export function transformRequestForFontGlyph(url: string, resourceType: string) {
    // Check if this is a request to our server (not to Azure Maps)
    const isEspatialRequest = url.indexOf(es.appUrl) > -1 || url.indexOf(es.restUrl) > -1 || url.indexOf(es.url) > -1;

    try {
        if ( resourceType == "Glyphs" &&
            url.indexOf("/styling/glyphs/") > -1 &&
            !ATLAS_SUPPORTED_FONTS.find(fontName => url.includes(fontName)) // if the font is supported by atlas then leave the rq alone
        ) {
            // azure:    https://{{azMapsDomain}}/{{azMapsStylingPath}}/glyphs/{fontstack}/{range}.pbf
            // eSpatial: https://ess-cb8j.office.espatial.com/esWebApp/rest/v1b/style/glyphes/{fontstack}/{range}.pbf

            // bad:  https://atlas.microsoft.com/styling/glyphs/ArchitectsDaughter-Regular/0-255.pbf
            // good: https://ess-cb8j.office.espatial.com/esWebApp/rest/v1b/style/glyphes/ArchitectsDaughter-Regular/0-255.pbf

            // alter this request on the fly
            const fixedUrl = es.restUrl + "/style/glyphes/" + url.substring(url.indexOf("/glyphs/") + 8) + (es.isPublicAccess ? "&TENANT_ID=" + es.tenantId : "")

            // handy for troubleshooting. seems to be working ok now
            //console.log("transformRequest : altering glyph url", url, "->", fixedUrl);

            // Glyph requests to eSpatial server get the request ID header
            return { url: fixedUrl, headers: { "X-Request-Id": generateRequestId() } };
        }
    } catch (err) {
        console.error("Error attempting to rewrite glyph url: " + url, err);
    }

    // Add X-Request-Id header for eSpatial server requests (tiles, features, etc.)
    if (isEspatialRequest && !es.isPublicAccess) {
        return { url: url, headers: { "X-Request-Id": generateRequestId() } };
    }

    // Return the URL unchanged by default (for Azure Maps requests).
    return { url: url };
}